import React, { useState, useEffect, useContext } from 'react';
import { PassengerAPI } from '../../../../../../../../API/PassengerAPIs/PassengerAPIs';
import { format} from 'date-fns';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import './ViewTourTableInfo.css';
import ViewTourInfo from '../ViewTourInfo/ViewTourInfo';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export default function ViewTourTableInfo({tourID, selectedTour, setSelectedTour, showCompleted, passenger}){

    const navigate = useNavigate();
    const notificationCtx = useContext(NotificationContext);

    const [loading, setLoading] = useState(true);
    const [tourInfo, setTourInfo] = useState();
    const getTourInfo = () => {
        PassengerAPI.GetTourDetails(tourID)
        .then((response) => {
            if(response.status === 200){
                setTourInfo(response.data);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err);
            ApiResponseHandler(err.response, notificationCtx, navigate);
        })
    }

    useEffect(() => {
        getTourInfo();
    }, [])

    const handleCheck = () => {
        if(selectedTour){
            if(tourID === selectedTour.bookingId){
                setSelectedTour(null);
            }
            else{
                setSelectedTour(tourInfo);
            }
        }
        else{
            setSelectedTour(tourInfo);
        }
    }

    // if(loading){
    //     return(<tr><td>Loading...</td></tr>)
    // }
    // else if(showCompleted){
    //     return(
    //         <tr onClick={handleCheck}>
    //             <td>{tourInfo.destinations[0]}</td>    
    //             <td>{tourInfo.bookingId}</td>    
    //             <td>{format(new Date(tourInfo.dateOfTravel), 'dd-LLL-yyyy')}</td>    
    //             <td>
    //                 <input type='checkbox' checked={selectedTour?.bookingId === tourID} readOnly />
    //             </td>    
    //         </tr>
    //     )
    // }
    // else if(tourInfo.dateOfTravel > format(new Date(), 'T')){
    //     return(
    //         <tr onClick={handleCheck}>
    //             <td>{tourInfo.destinations[0]}</td>    
    //             <td>{tourInfo.bookingId}</td>    
    //             <td>{format(new Date(tourInfo.dateOfTravel), 'dd-LLL-yyyy')}</td>    
    //             <td>
    //                 <input type='checkbox' checked={selectedTour?.bookingId === tourID} readOnly />
    //             </td>    
    //         </tr>
    //     )
    // }


    if(loading){
        return(
            <div className='tour-details-container'>
                <div>Loading...</div>
            </div>
        )
    }
    else if(showCompleted){
        return(
            <div className='tour-details-container' >
                <div className='tour-basic-details-line' onClick={handleCheck}>
                    <span>{tourInfo.destinations[0]}</span>    
                    <span>{tourInfo.bookingId}</span>    
                    <span>{format(new Date(tourInfo.dateOfTravel), 'dd-LLL-yyyy')}</span>    
                    <span>
                        {selectedTour?.bookingId === tourID ? <FaChevronUp /> : <FaChevronDown />}
                    </span>  
                </div>
                <div className={selectedTour?.bookingId === tourID ? 'tour-full-details active' : 'tour-full-details'}>
                    {selectedTour?.bookingId === tourID && <ViewTourInfo passenger={passenger} tour={selectedTour}/>}
                </div>
                  
            </div>
        )
    }
    else if(tourInfo.dateOfTravel > format(new Date(), 'T')){
        return(
            <div className='tour-details-container' >
                <div className='tour-basic-details-line' onClick={handleCheck}>
                    <span>{tourInfo.destinations[0]}</span>    
                    <span>{tourInfo.bookingId}</span>    
                    <span>{format(new Date(tourInfo.dateOfTravel), 'dd-LLL-yyyy')}</span>    
                    <span>
                    {selectedTour?.bookingId === tourID ? <FaChevronUp /> : <FaChevronDown />}
                    </span> 
                </div>
                <div className={selectedTour?.bookingId === tourID ? 'tour-full-details active' : 'tour-full-details'}>
                    {selectedTour?.bookingId === tourID && <ViewTourInfo passenger={passenger} tour={selectedTour}/>}
                </div>
                   
            </div>
        )
    }
}